import { Box, Grid, Stack, Typography } from '@mui/material';
import { ImageWithLoader } from '@xolv-mybrightlink/common';
import { FormattedMessage } from 'react-intl';
import { useResoureCardOrientation } from '../hooks/useResourceCardOrientation';
import { ResourceItem } from '../pages/ResourcesPage';

interface ResourcesProps {
  onClick: () => void;
  item: ResourceItem;
  index: number;
  totalLength: number;
}

interface CardProps {
  onClick: () => void;
  item: ResourceItem;
}

export const ResourceCard = (props: ResourcesProps) => {
  const orientation = useResoureCardOrientation(props.totalLength, props.index);

  return orientation == 'horizontal' ? (
    <HorizontalResourceCard onClick={props.onClick} item={props.item} />
  ) : (
    <VerticalResourceCard onClick={props.onClick} item={props.item} />
  );
};

const HorizontalResourceCard = (props: CardProps) => {
  const { onClick, item } = props;
  return (
    <Grid
      item
      xs={1}
      xl={1.5}
      sx={{
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'center',
        cursor: 'pointer',
      }}
    >
      <Stack
        onClick={onClick}
        direction={'row'}
        justifyContent={'space-between'}
        sx={{
          width: 500,
          height: 347,
          borderRadius: 3,
          boxShadow: '0 12px 16px 0 #3b45590c, 0 8px 10px 0 #3b455919',
          backgroundImage: `linear-gradient(to right, ${item.gradientStartColor} 0%, ${item.gradientEndColor} 100%)`,
        }}
      >
        <Stack
          direction={'column'}
          sx={{
            mt: 21,
            pl: 10,
            pr: 16,
            width: '100%',
          }}
        >
          <Typography
            sx={{
              fontWeight: 600,
              fontSize: 24,
            }}
          >
            <FormattedMessage id={item.title ? item.title : item.labelKey} />
          </Typography>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              backgroundColor: 'info.main',
              borderRadius: 5.5,
              mt: 5,
            }}
          >
            <Typography
              variant='body2'
              sx={{
                mx: 5,
                my: 2.5,
              }}
            >
              <FormattedMessage id='resources.button.learn-more' />
            </Typography>
          </Box>
        </Stack>

        <ImageWithLoader
          src={item.backgroundImage}
          style={{
            paddingTop: '34px',
            paddingBottom: '34px',
            marginRight: '-40px',
          }}
          loaderSxProps={{ minHeight: 50 }}
        />
      </Stack>
    </Grid>
  );
};

const VerticalResourceCard = (props: CardProps) => {
  const { onClick, item } = props;
  return (
    <Grid
      item
      xs={1}
      xl={1}
      sx={{
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'center',
        cursor: 'pointer',
      }}
    >
      <Stack
        onClick={onClick}
        sx={{
          width: 347,
          height: 418,
          borderRadius: 3,
          direction: 'column',
          boxShadow: '0 12px 16px 0 #3b45590c, 0 8px 10px 0 #3b455919',
          backgroundImage: `linear-gradient(to right, ${item.gradientStartColor} 0%, ${item.gradientEndColor} 100%)`,
        }}
      >
        <ImageWithLoader
          src={item.backgroundImage}
          style={{
            paddingLeft: '34px',
            paddingRight: '34px',
            marginTop: '-40px',
          }}
          loaderSxProps={{ minHeight: 50 }}
        />
        <Typography
          sx={{
            fontWeight: 600,
            fontSize: 24,
            mt: 10,
            paddingLeft: 10,
            paddingRight: 2,
          }}
        >
          <FormattedMessage id={item.title ? item.title : item.labelKey} />
        </Typography>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            backgroundColor: 'info.main',
            maxWidth: '50%',
            marginLeft: 10,
            marginRight: 10,
            borderRadius: 5.5,
            px: 5,
            py: 2.5,
            mt: 5,
            mb: 10,
          }}
        >
          <Typography variant='body2'>
            <FormattedMessage id='resources.button.learn-more' />
          </Typography>
        </Box>
      </Stack>
    </Grid>
  );
};
